import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getTokenCount } from '@/api/rtk/userSelectors'
import { clearCache, handleLogout } from '@/features/auth/lib/authSession'
import { HELP_URL } from '@/shared/config/urls'
import { DropdownMenu } from '@radix-ui/react-dropdown-menu'
import { 
  DropdownMenuContent, 
  DropdownMenuGroup, 
  DropdownMenuItem, 
  DropdownMenuLabel, 
  DropdownMenuSeparator, 
  DropdownMenuShortcut, 
  DropdownMenuTrigger 
} from "@/shared/ui/dropdown-menu"
import { Button } from "@/shared/ui/button"
import { Dialog, DialogContent, DialogTrigger } from "@/shared/ui/dialog"
import AddToken from '@/features/profile/AddToken'
import AddTokensIcon from '@/images/SVG/AddTokensIcon.svg'
import SettingsIcon from '@/images/SVG/SettingsIcon.svg'
import LogOutIcons from '@/images/SVG/LogOutIcon.svg'
import MenuIcon from '@/images/SVG/menuIcon.svg'
import CloseIcon from '@/images/closeIcon.png'
import { FaRegCircleQuestion as HelpIcon } from "react-icons/fa6"
import { useTranslation } from 'react-i18next'

const MobileMenu = ({ 
  isMenuOpen, 
  setIsMenuOpen, 
  addTokenOpen, 
  setAddTokenOpen 
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const tokens = useSelector(getTokenCount)

  return (
    <div className='flex md:hidden'>
      <DropdownMenu open={isMenuOpen} onOpenChange={setIsMenuOpen}>
        <DropdownMenuTrigger asChild>
          <Button className='p-0 flex-none focus:border-none hover:bg-transparent cursor-pointer' variant="ghost">
            <img 
              src={isMenuOpen ? CloseIcon : MenuIcon} 
              alt='Menu Icon' 
              className='w-[14px] h-[14px] object-contain' 
            />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="w-[290px] fixed -right-[28px] top-3 rounded-[14px]">
          <DropdownMenuLabel>{t('header.menu')}</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuGroup>
            <DropdownMenuItem>
              <Dialog open={addTokenOpen} onOpenChange={(open) => {
                if (open) setIsMenuOpen(false);
                setAddTokenOpen(open);
              }}>
                <DialogTrigger className='flex items-center justify-between w-full'>
                  <div className='flex gap-2 items-center'>
                    <img src={AddTokensIcon} alt="" />
                    <span className='font-SuisseIntlLight font-semibold'>{t('tokens.add')}</span>
                  </div>
                  <DropdownMenuShortcut className='tracking-wider'>
                    {tokens?.toLocaleString('en')} {t('tokens.title')}
                  </DropdownMenuShortcut>
                </DialogTrigger>
                <DialogContent className="rounded-3xl" addingReport>
                  <AddToken setIsOpen={setAddTokenOpen} />
                </DialogContent>
              </Dialog>
            </DropdownMenuItem>
            <DropdownMenuItem className='cursor-pointer' onClick={() => window.open(HELP_URL, '_blank')}>
              <div className='flex gap-2 items-center'>
                <HelpIcon size={16} />
                <span className='font-SuisseIntlLight font-semibold'>{t('navigation.help')}</span>
              </div>
            </DropdownMenuItem>
            <DropdownMenuItem className='cursor-pointer' onClick={() => navigate('/settings')}>
              <img src={SettingsIcon} alt="" />
              <span className='font-SuisseIntlLight font-semibold'>{t('navigation.settings')}</span>
            </DropdownMenuItem>
          </DropdownMenuGroup>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleLogout} className='cursor-pointer'>
            <img src={LogOutIcons} alt="" />
            <span className='font-SuisseIntlLight font-semibold text-red-500'>{t('navigation.logout')}</span>
          </DropdownMenuItem>
          <DropdownMenuItem onClick={clearCache} className='cursor-pointer'>
            <span className='font-SuisseIntlLight text-gray-400'>{t("actions.clearCache")}</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}

export default MobileMenu
